<template>
  <div class="page-view">
    <div class="header-row">
      <div>
        <h2>登录告警</h2>
        <p>记录异常登录、黑名单 IP 和新 IP 登录告警。</p>
      </div>
      <el-button type="primary" plain @click="loadData">刷新</el-button>
    </div>

    <div class="brand-card filter-card">
      <div class="toolbar-row">
        <el-input v-model="filters.keyword" placeholder="账号 / IP / 内容" clearable />
        <el-select v-model="filters.alert_type" placeholder="告警类型" clearable>
          <el-option v-for="item in alertTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
        <el-select v-model="filters.is_handled" placeholder="处理状态" clearable>
          <el-option label="未处理" :value="false" />
          <el-option label="已处理" :value="true" />
        </el-select>
        <el-button type="primary" plain @click="handleQuery">查询</el-button>
      </div>
    </div>

    <div class="brand-card table-card">
      <el-table :data="items" stripe>
        <el-table-column prop="created_at" label="时间" min-width="180" />
        <el-table-column label="类型" min-width="180">
          <template slot-scope="{ row }">{{ alertTypeLabel(row.alert_type) }}</template>
        </el-table-column>
        <el-table-column prop="username" label="账号" min-width="120" />
        <el-table-column prop="role" label="角色" min-width="100" />
        <el-table-column prop="ip" label="IP" min-width="150" />
        <el-table-column prop="message" label="内容" min-width="360" />
        <el-table-column prop="is_handled" label="状态" width="90">
          <template slot-scope="{ row }">{{ row.is_handled ? "已处理" : "未处理" }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button v-if="!row.is_handled" size="mini" type="warning" plain @click="handleItem(row)">已处理</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager-row">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes"
          :total="total"
          :page-size="pager.page_size"
          :current-page="pager.page"
          :page-sizes="[10, 20, 50]"
          @current-change="onPageChange"
          @size-change="onSizeChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { fetchLoginAlerts, handleLoginAlert } from "../api/orders";

const alertTypeOptions = [
  { label: "连续输错触发IP封禁", value: "IP_BLOCK_TRIGGERED" },
  { label: "账号被锁定", value: "ACCOUNT_LOCKED" },
  { label: "黑名单IP尝试登录", value: "BLACKLIST_IP_LOGIN" },
  { label: "管理员/超管新IP登录", value: "ADMIN_NEW_IP_LOGIN" },
];

export default {
  data() {
    return {
      alertTypeOptions,
      filters: { keyword: "", alert_type: "", is_handled: "" },
      items: [],
      total: 0,
      pager: { page: 1, page_size: 10 },
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const { data } = await fetchLoginAlerts({
        keyword: this.filters.keyword || undefined,
        alert_type: this.filters.alert_type || undefined,
        is_handled: this.filters.is_handled === "" ? undefined : this.filters.is_handled,
        page: this.pager.page,
        page_size: this.pager.page_size,
      });
      this.items = data.items || [];
      this.total = data.total || 0;
    },
    handleQuery() {
      this.pager.page = 1;
      this.loadData();
    },
    onPageChange(page) {
      this.pager.page = page;
      this.loadData();
    },
    onSizeChange(size) {
      this.pager.page = 1;
      this.pager.page_size = size;
      this.loadData();
    },
    alertTypeLabel(value) {
      return this.alertTypeOptions.find((item) => item.value === value)?.label || value || "-";
    },
    async handleItem(row) {
      await handleLoginAlert(row.id);
      this.$message.success("已标记处理");
      this.loadData();
    },
  },
};
</script>

<style scoped>
</style>
